import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from "react-intl";

//Components
import { useTimeFrameComponent } from '@gpstrackit/gtc-react-controls';
import { Button } from 'Components';

//Views
import VicinityToolSettings from './.components/vicinityToolSettings';
import VicinityToolUnits from './.components/vicinityToolUnits';
import MapObject from 'Components/Map/providers/mapObject'

//Enums
import { MapUtilitiesTypes } from 'Modules/realtimeMaps/main/components/MapUtilitiesMenu/enums';
import { TypeLayer, TypeObjectMap } from '../../../../../components/Map/providers/enums';

//Actions
import { vicinityToolSetField, vicinityToolReset } from './redux/slice';
import { selectModuleMapSettings } from 'Redux/actions';
const VicinityTool = (props) => {

    const { messages } = useIntl();
    const { mapRef } = props;

    const fromToMapRef = useRef();
    const formRef = useRef();
    const dispatch = useDispatch();

    //Variables - TimeFrame
    const timeFrameOptions = [
        { id: "custom", label: messages['date_custom'] },
        { id: "today", label: messages['date_today'] },
        { id: "yesterday", label: messages['date_yesterday'] }
    ]
    const timeFrame = useTimeFrameComponent(timeFrameOptions);

    //Redux States
    const { loading, result, step, shape, coordinates, radius, showNewLayer } = useSelector(state => state.realtimeMapsVicinityTool);

    const generateSvgIcon = (color) => {

        let svg = `
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="${color}"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/></svg>
        `
        let svgIcon = {
            url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg),
            scaledSize: new google.maps.Size(32, 32)
        };
        return svgIcon
    }

    const buildMarker = (id, position, color) => {
        const svgIcon = generateSvgIcon(color)
        const marker = new MapObject().buildMarker({
            id: id,
            position: position,
            layerName: TypeLayer.VicinityTool,
            label: '',
            heading: 0,
            color: color,
            eventName: 'no event',
            draggable: false,
            icon: svgIcon
        })
        mapRef?.current?.addMapObject(marker);
    }

    const addObjects = (id, arrayPositions, color) => {
        let newCoordinates = arrayPositions.length ? arrayPositions.map((item) => ({
            lat: parseFloat(item.latitude || 0),
            lng: parseFloat(item.longitude || 0)
        })) : []
        if (newCoordinates.length && mapRef) {
            let startPosition = newCoordinates[0]
            let endPosition = newCoordinates[newCoordinates.length - 1]
            mapRef.current.addMapObject(new MapObject().buildPolyLine({
                id: `${id}-polyline`,
                coordinates: newCoordinates,
                layerName: TypeLayer.VicinityTool,
                label: 'Polyline Vicinity Tool',
                heading: 0,
                color: color,
                fillOpacity: 0.6,
                strokeWeight: 8
            }));
            buildMarker(`${id}-marker-1`, startPosition, color);
            buildMarker(`${id}-marker-2`, endPosition, color);
        }
    }

    const deleteObject = (id) => {
        mapRef.current.removeMapObject(`vicinity-tool-${id}-polyline`, TypeObjectMap.Polyline);
        mapRef.current.removeMapObject(`vicinity-tool-${id}-marker-1`, TypeObjectMap.Marker);
        mapRef.current.removeMapObject(`vicinity-tool-${id}-marker-2`, TypeObjectMap.Marker);
    }

    const addShape = (currentId, newId) => {
        if (shape.shape === "circle") {

            if (coordinates.length && radius > 0) {
                let position = {
                    lat: coordinates[0].latitude,
                    lng: coordinates[0].longitude
                }
                const circle = new MapObject().buildCircle({
                    id: newId,
                    position: position,
                    layerName: TypeLayer.VicinityTool,
                    radius: radius,
                    label: '',
                    heading: 0,
                    color: '#0098dc',
                    eventName: 'no event',
                })
                mapRef.current.addMapObject(circle);
            }
        }

        if (shape.shape === "square") {
            let tempCoordinates = coordinates.length ? coordinates.map((item) => ({ lat: item?.latitude, lng: item?.longitude })) : []
            if (tempCoordinates.length) {
                mapRef.current.addMapObject(new MapObject().buildPolygon({
                    id: newId,
                    coordinates: tempCoordinates,
                    layerName: TypeLayer.VicinityTool,
                    label: '',
                    heading: 0,
                    color: '#0098dc',
                }));
            }
        }

        if (shape.shape === "polygon") {
            let tempCoordinates = coordinates.length ? coordinates.map((item) => ({ lat: item?.latitude, lng: item?.longitude })) : []
            if (tempCoordinates) {
                mapRef.current.addMapObject(new MapObject().buildPolygon({
                    id: newId,
                    coordinates: tempCoordinates,
                    layerName: TypeLayer.VicinityTool,
                    label: '',
                    heading: 0,
                    color: '#0098dc'
                }));
            }
        }
    }

    useEffect(() => {
        if (result.length && step === "settings") {

            mapRef.current.removeMapObject("mapObject_01", TypeObjectMap.Circle);
            mapRef.current.removeMapObject("vicinityTool01", TypeObjectMap.Marker);
            dispatch(vicinityToolSetField({ step: "units" }))
            result.map((item, index) => {
                addObjects(`vicinity-tool-${index}`, item?.events, item?.color);
            })

            mapRef.current.showLayer(TypeLayer.PolygonCreate, false);
            mapRef?.current?.removeLayer(TypeLayer.CircleCreate);
            mapRef?.current?.removeLayer(TypeLayer.SquareCreate);
            addShape("mapObject_01", "mapObject_02");

        }
    }, [result])

    useEffect(() => {
        if (showNewLayer && result.length) {
            result.map((item, index) => {
                if (item?.show) {
                    addObjects(`vicinity-tool-${index}`, item?.events, item?.color);
                }
                
                mapRef.current.showLayer(TypeLayer.Units, false);
                mapRef.current.showLayer(TypeLayer.UnitLabel, false);
            })

            addShape("mapObject_01", "mapObject_02");
            dispatch(vicinityToolSetField({ showNewLayer: false }))
        }
    }, [showNewLayer])

    return (
        <div>
            <div>
                {step === "settings" &&
                    <VicinityToolSettings
                        mapRef={mapRef}
                        formRef={formRef}
                        timeFrame={timeFrame}
                        fromToMapRef={fromToMapRef}
                    />
                }
                {step === "units" &&
                    <VicinityToolUnits
                        mapRef={mapRef}
                        deleteObject={deleteObject}
                        addObjects={addObjects}
                        generateSvgIcon={generateSvgIcon}
                        timeFrame={timeFrame}
                        addShape={addShape}
                    />
                }
            </div>
            <div style={{ display: 'flex', justifyContent: 'end', marginTop: 2 }}>
                {
                    step === "settings" &&
                    <Button
                        disabled={loading}
                        className="btn-cancel"
                        onClick={(e) => {
                            if (e) e.preventDefault();
                            fromToMapRef?.current?.resetComponent();
                            dispatch(vicinityToolReset());
                            dispatch(selectModuleMapSettings(MapUtilitiesTypes.Default))
                        }}
                    >
                        {messages['cancel']}
                    </Button>
                }
                <Button
                    disabled={loading || (!shape?.shape)}
                    className="btn-blue"
                    onClick={(e) => {
                        if (e) e.preventDefault();
                        if (step === "units") {
                            mapRef.current.removeLayer(TypeLayer.VicinityTool);
                            dispatch(vicinityToolSetField({ step: "settings", result: [] }))
                        } else {
                            formRef.current.submit();
                        }
                    }}
                >
                    {step === "units" ? messages['back'] : messages['next']}
                </Button>
            </div>
        </div>
    )
}

export default VicinityTool